/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterOptionDto
 */
export interface FilterOptionDto {
    /**
     * 
     * @type {string}
     * @memberof FilterOptionDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FilterOptionDto
     */
    name: string;
}

/**
 * Check if a given object implements the FilterOptionDto interface.
 */
export function instanceOfFilterOptionDto(value: object): value is FilterOptionDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function FilterOptionDtoFromJSON(json: any): FilterOptionDto {
    return FilterOptionDtoFromJSONTyped(json, false);
}

export function FilterOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function FilterOptionDtoToJSON(json: any): FilterOptionDto {
    return FilterOptionDtoToJSONTyped(json, false);
}

export function FilterOptionDtoToJSONTyped(value?: FilterOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

